import React from 'react';
import { IconProps } from '.';

const SvgColoredSiren = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill='#262829' d='M2 19a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-2Z' />
      <path fill='#F33' d='M4 10a8 8 0 1 1 16 0v8H4v-8Z' />
      <path
        fill='#fff'
        fillRule='evenodd'
        d='M11 14.5c0-.552.445-1 .993-1h.014c.548 0 .993.448.993 1s-.445 1-.993 1h-.014a.997.997 0 0 1-.993-1Z'
        clipRule='evenodd'
      />
      <path fill='#fff' d='M11 6.5a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0v-4Z' />
    </svg>
  );
};

export default SvgColoredSiren;
